<template>
    <div style="align-items: center; padding-bottom:1rem;">
        <InfosComponent></InfosComponent>
    </div>
</template>
  
<script>
import InfosComponent from './InfosComponent.vue'

export default {
  components: {
    InfosComponent
  },
}
</script>
  
<style scoped>
</style>
  